import type { ApiModels } from '@ori/global-api-client';
import useSWR from 'swr';

import { useConfiguration } from '~/shared/contexts/configurationContext';
import type { ApiError } from '~/shared/models/ApiError';
import type { FetcherOptions } from '~/shared/types/FetcherOptions';
import { getSafeUrl } from '~/shared/utils/getSafeUrl';

export function useRecurringPaymentCards() {
  const { customerId, tenant, globalApiUrl } = useConfiguration();

  return useSWR<ApiModels.GlobalCustomersRecurringPaymentCardsDto, ApiError>(
    () => {
      if (!customerId) {
        return null;
      }

      const url = getSafeUrl(`/customers/${customerId}/recurringPaymentCards`, globalApiUrl);
      const options: FetcherOptions = {
        tenant,
      };

      return [url, options];
    },
    { revalidateOnFocus: false },
  );
}
